import img1 from '../images/buywatch/BEXSONN-removebg-preview.png'
import img2 from '../images/buywatch/hangingwatch1-removebg-preview.png'
import img3 from '../images/buywatch/Clooney_wears.png'
import img4 from '../images/buywatch/Introducing_Patek.png'
import img5 from '../images/buywatch/goldenwatch.png'
import img6 from '../images/buywatch/The_Rolex_Cellini.png'

const Data=[
    
    {

        id:1,
     img:img1,
     name:"Quartz",
     price:12
    },
    {
        id:2,
     img:img2,
     name:"Tomz",
     price:21
    },
    {
        id:3,
     img:img3,
     name:"Merol",
     price:50
    },
    {
        id:4,
     img:img4,
     name:"Tesla",
     price:32
    },
    {
        id:5,
     img:img5,
     name:"Arada",
     price:23
    },
    {
        id:6,
     img:img6,
     name:"Sebi",
     price:12
    },
]
export default Data